import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { forwardRef, useState, useCallback } from 'react';
import BaseTextArea from './base/textarea/BaseTextArea.mjs';
import { TextAreaProvider } from './base/textarea/context.mjs';
import Footer from './base/textarea/Footer.mjs';
import HelperText from './base/textarea/HelperText.mjs';
import Label from './base/textarea/Label.mjs';
import TextAreaLabel_Legacy from './base/textarea/Label_Legacy.mjs';

const InnerTextArea = forwardRef(
  ({
    size = "default",
    required = false,
    variant = "outline",
    minRows = 5,
    ...props
  }, forwardedRef) => {
    const [describedBy, _setDescribedBy] = useState();
    const [labelledBy, _setLabelledBy] = useState();
    const setDescribedBy = useCallback((describeById) => {
      _setDescribedBy(describeById);
    }, []);
    const setLabelledBy = useCallback((labelledById) => {
      _setLabelledBy(labelledById);
    }, []);
    const [footer, setFooter] = useState(null);
    return /* @__PURE__ */ jsx(
      TextAreaProvider,
      {
        size,
        required,
        state: props.state,
        disabled: props.disabled,
        setDescribedBy,
        setLabelledBy,
        footerElement: footer,
        onFooterElementChange: setFooter,
        children: /* @__PURE__ */ jsx(
          BaseTextArea,
          {
            minRows,
            ...props,
            describedBy,
            labelledBy,
            size,
            variant,
            required,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
const TextArea = Object.assign({}, InnerTextArea, {
  Label_Legacy: styled(TextAreaLabel_Legacy),
  Label: styled(Label),
  Footer: styled(Footer),
  HelperText: styled(HelperText)
});

export { TextArea as default };
//# sourceMappingURL=TextArea.mjs.map
